/**
 * Employer dashboard greeting line (Session 6 item 5).
 *
 * The noun AND the verb agree with the active-job count. The old
 * inline DashboardShell copy pluralised the noun only, so a single
 * posting read "Your 1 active job posting are attracting candidates."
 * on the employer dashboard during the October 2026 employer walk.
 * Zero (or a missing/non-numeric stat) keeps the neutral line.
 */
export function employerGreetingText(activeJobs: unknown): string {
  const n = typeof activeJobs === 'number' && Number.isFinite(activeJobs) ? activeJobs : 0;
  if (n === 1) return 'Your 1 active job posting is attracting candidates.';
  if (n > 1) return `Your ${n} active job postings are attracting candidates.`;
  return "Here's what's happening with your recruitment.";
}
